import { render } from "./FadeAwayMessage.vue?vue&type=template&id=2ca94885&scoped=true"
import script from "./FadeAwayMessage.vue?vue&type=script&lang=js"
export * from "./FadeAwayMessage.vue?vue&type=script&lang=js"

import "./FadeAwayMessage.vue?vue&type=style&index=0&id=2ca94885&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca94885"]])

export default __exports__